import React , {Component} from 'react'
import {Container,Button} from 'reactstrap'
import './login.css'
import  { Redirect } from 'react-router-dom' 
import {withRouter,NavLink} from 'react-router-dom'
import { connect } from "react-redux";
import * as actionCreators from '../../Actions/Index';
import Cookies from 'universal-cookie';
const cookies = new Cookies();

class Login extends Component{
    constructor(props){
        super(props);
 
        this.state = {
            account: {},
            errors: {},
            name:"",
            password:"",
            userInfo:[],
            redirect: false
        }
     }
     handleChange(field, e){         
        let account = this.state.account;
        account[field] = e.target.value;        
        this.setState({account});
    }
    handleValidation(){
        let account = this.state.account;
        let errors = {};
        let formIsValid = true;

        //Name
        if(!account["mail"]){
           formIsValid = false;
           errors["mail"] = "Cannot be empty";
        }
           if(!account["password"]){
           formIsValid = false;
           errors["password"] = "Cannot be empty";
        }
       this.setState({errors: errors});
       return formIsValid;
    }

    contactSubmit(e){
        e.preventDefault();

        if(this.handleValidation()){
          this.props.login(this.state.account);
          this.setState({userInfo:this.props.userInfo});
          if(this.props.loginStatus == true){
              this.setState({redirect:true});
          }
         
        }else{
           alert(this.state.errors["mail"])
        } }
render(){return(
  <div>
{!this.state.redirect?
<Container className="UPContainer">
    <div className="leftlogin">
             
    <div className="loginCard">

    <form name="contactform" className="contactform" onSubmit= {this.contactSubmit.bind(this)}>
          
    <div class="f0n8F FATdn " style={{marginTop: "14%"}}>
        <label for="f955a63d446b2c" class="_9nyy2">Phone number, username, or email</label>
        <input class="_2hvTZ pexuQ zyHYP" id="f955a63d446b2c" aria-describedby="slfErrorAlert" onChange={this.handleChange.bind(this, "mail")} 
        aria-label="Phone number, username, or email" aria-required="true" autocapitalize="off" autocorrect="off" maxlength="75" name="mail" type="text"/>
        </div>

        <div class="f0n8F FATdn " style={{marginTop: "4%"}}>
        <label for="f955a63d446b2c" class="_9nyy2">Password</label>
        <input class="_2hvTZ pexuQ zyHYP" id="f955a63d446b2c" aria-describedby="slfErrorAlert" onChange={this.handleChange.bind(this, "password")} 
        aria-label="Password" aria-required="true" autocapitalize="off" autocorrect="off" maxlength="75" name="password" type="password"/>
        </div>

        <div className="loginButton">
           <Button type="submit" color="success">Sign In</Button>
           </div>
           </form>
           <div className="forgotpass">
           <p className="forgothead">Forgot password?</p>
           </div>
   </div>
   <div className="signupcard">
       <p className="signupp">Don't have an account?<NavLink to="signup"> Sign up</NavLink></p>
   </div>

   </div>
</Container>
:<div><Redirect to="/" /></div>}
</div>

)}
}
const mapStateToProps = (state) => ({
    userExist:state.userExist,
    loginRequestStatus:state.loginRequestStatus,
    loginStatus:state.loginStatus,
    userInfo:state.userInfo
  })
  
  const mapDispatchToProps = dispatch => {
    return {
      login: (account) => dispatch(actionCreators.login(account))
    }
  }
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Login));